// LOAD ALL THE READ ONLY DATA
import { toast } from "react-toastify";
import { TIPO_PIEZAS_API } from "../views/MainLayout/components/shared/services/tipo_piezas";
import { makeSetReducer } from "./utils";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";

export const tipoPiezasFullfilledReducer = makeSetReducer(['tipo_piezas/fullfilled']);

export const fetchTipoPiezas = () => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await TIPO_PIEZAS_API.get()
        const data = await response.data;
        dispatch({type: 'tipo_piezas/fullfilled', payload: data});
        const readOnly = JSON.parse(localStorage.getItem('read_only'));
        readOnly.tipo_piezas = data;
        localStorage.setItem('read_only', JSON.stringify(readOnly));
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}